import {
  ChimeCabinLivestream,
  useChimeCredentials,
} from './ChimeCabinLivestream'
import { LoadingLivestream } from './components/LoadingLivestream'

export const CabinLivestream = ({ vehicleId }: { vehicleId: string }) => {
  const { loading, isChimeAvailable, credentials } =
    useChimeCredentials(vehicleId)

  if (loading) {
    return <LoadingLivestream />
  }

  if (isChimeAvailable && credentials) {
    return (
      <ChimeCabinLivestream credentials={credentials} vehicleId={vehicleId} />
    )
  } else {
    return <LoadingLivestream />
  }
}
